export default "__VITE_ASSET__BnR7SKx4__"